import { render, staticRenderFns } from "./salary-sendrecord-item.vue?vue&type=template&id=045133b4&scoped=true&"
import script from "./salary-sendrecord-item.vue?vue&type=script&lang=js&"
export * from "./salary-sendrecord-item.vue?vue&type=script&lang=js&"
import style0 from "./salary-sendrecord-item.vue?vue&type=style&index=0&id=045133b4&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "045133b4",
  null
  
)

export default component.exports